import { inject, Injectable } from '@angular/core';

import type { PeEventHub } from '@pe/checkout/payment-events-hub';
import { PE_ENV } from '@pe/common';

@Injectable()
export class EventsHubService {
  private readonly env = inject(PE_ENV);

  private eventHub: PeEventHub;

  async init(apiCallId: string) {
    if (apiCallId) {
      const { createEventsHub } = await import('@pe/checkout/payment-events-hub');

      this.eventHub = await createEventsHub({
        apiCallId: apiCallId,
        environment: {
          checkoutWrapper: this.env.frontend.checkoutWrapper,
        },
      });
    }
  }

  postMessage(payload: object, apiCallId: string): Promise<void> {
    if (!this.eventHub) {
      return Promise.reject('EventsHubService not initialized');
    }

    return this.eventHub.emit({
      ...payload,
      apiCallId,
    });
  }
}
